import { render, staticRenderFns } from "./ModalToneladasAtendidasNaSemana.vue?vue&type=template&id=48731e30"
import script from "./ModalToneladasAtendidasNaSemana.vue?vue&type=script&lang=js"
export * from "./ModalToneladasAtendidasNaSemana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports